module.exports = __webpack_public_path__ + "img/thumbnail_Gharial_j_albino.8c930c2c.png";